export default function StickyMobileBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-md-sky/60 bg-white/90 px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur-md md:hidden">
      <div className="mx-auto flex max-w-[1280px] gap-3">
        <a
          href="tel:+573206789030"
          className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-md-dark py-3 text-[14px] font-semibold text-white transition-transform active:scale-95"
          onClick={() => {
            if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdCallClick) {
              ((window as unknown as Record<string, unknown>).mdCallClick as () => void)();
            }
          }}
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-phone-line" />
          </span>
          Llamar
        </a>
        <a
          href="https://wa.me/573206789030?text=Hola,%20quiero%20pedir%20un%20domicilio"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-md-teal py-3 text-[14px] font-semibold text-white transition-transform active:scale-95"
          onClick={() => {
            if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdWaClick) {
              ((window as unknown as Record<string, unknown>).mdWaClick as () => void)();
            }
          }}
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-whatsapp-line" />
          </span>
          WhatsApp
        </a>
      </div>
    </div>
  );
}